import { profileHref } from "@/lib/profile-url"

interface NotificationLike {
  type: string
  _source?: string
  companion?: { id?: string } | null
  companion_id?: string
  data?: Record<string, unknown> | null
}

export function getNotificationUrl(notif: NotificationLike): string | null {
  const d = notif.data ?? {}

  if (notif._source === "companion") {
    const cid = (notif.companion as any)?.id ?? notif.companion_id ?? (d.companion_id as string)
    return cid ? `/goonpals/chat/${cid}` : null
  }

  // A notification that carries its own in-app destination (a same-site path, never a full URL).
  if (typeof d.url === "string" && /^\/(?!\/)/.test(d.url)) return d.url

  if (d.bounty_id) return `/?tab=bounties&bounty=${d.bounty_id}`
  // Artist commissions have explicit flag; scriptor commissions go to the panel tab
  if (d.commission_id && d.artist_commission) return `/commissions/${d.commission_id}`
  if (d.commission_id) return `/?tab=commissions&commission=${d.commission_id}`
  if (d.widget_tracking_token) return `/w/${d.widget_tracking_token}`
  if (d.widget_commission_id) return "/widget/dashboard"

  if (d.script_id || notif.type === "script_sale" || notif.type === "content_flagged" || notif.type === "content_theft") {
    return "/marketplace"
  }

  // One follower links to their profile; a batch opens your own followers list.
  if (notif.type === "new_followers" && d.profile_id && d.count === 1) {
    return profileHref(d.profile_code as string | null, d.profile_username as string | null, String(d.profile_id))
  }
  if (notif.type === "new_followers") return "/profile?followers=1"

  return null
}
